module.exports = __webpack_public_path__ + "static/media/eye-close.843056ed.svg";